<template>
  <div class="magicBox">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>盲盒管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-actions" style="margin-top: 10px">
      <el-select v-model="status" placeholder="请选择状态">
        <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="getList">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>
    <div class="page-actions">
      <el-button type="primary" @click="add">新增盲盒</el-button>
    </div>

    <el-card class="page-content" shadow="never">
      <div class="list">
        <el-table :data="orderListData" border style="width: 100%">
          <el-table-column prop="blindBoxName" label="盲盒名称" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <!-- <span>{{scope.row.blindBoxName | langFormat}}</span> -->
              <span v-for="(item, index) in scope.row.nameObj" :key="index">
                <span v-if="item.lang === 'zh'">{{ item.name }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="盲盒等级">
            <template slot-scope="scope">
              <span v-if="scope.row.blindBoxGrade === 1">白银</span>
              <span v-if="scope.row.blindBoxGrade === 2">黄金</span>
              <span v-if="scope.row.blindBoxGrade === 3">铂金</span>
              <span v-if="scope.row.blindBoxGrade === 4">钻石</span>
              <span v-if="scope.row.blindBoxGrade === 5">超凡</span>
            </template>
          </el-table-column>
          <el-table-column prop="blindBoxTotal" label="总盒子数" />
          <el-table-column prop="blindBoxSurplus" label="剩余盒子数" />
          <el-table-column label="开始时间">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime | moment }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结束时间">
            <template slot-scope="scope">
              <span>{{ scope.row.endTime | moment }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 0">待上架</span>
              <span v-if="scope.row.state === 1">已上架</span>
              <span v-if="scope.row.state === 2">已下架</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="290">
            <template slot-scope="scope">
              <el-button
                  @click="updateStatus(scope.row)"
                  type="primary"
                  size="mini"
              >{{scope.row.state === 0 || scope.row.state === 2 ? '发布' : '下架'}}</el-button>
              <el-button
                  v-if="scope.row.state !== 1"
                  @click="editItem(scope.row)"
                  type="primary"
                  size="mini"
                  plain
              >编辑</el-button>
              <el-button
                  v-if="scope.row.state !== 1"
                  @click="delItem(scope.row)"
                  type="danger"
                  size="mini"
                  plain
              >删除</el-button>
              <el-button
                  v-if="scope.row.state === 1"
                  @click="infoItem(scope.row)"
                  type="primary"
                  size="mini"
                  plain
              >查看</el-button>
              <el-button
                  @click="openWhiteList(scope.row)"
                  type="primary"
                  size="mini"
                  plain
              >白名单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
          :size="pagination.size"
          :page="pagination.page"
          :total="total"
          @pageChanged="handlePageChanged"
      ></pagination>
    </el-card>
    <el-dialog :title="title" :visible.sync="boxShow" width="700px" :before-close="closeBox">
      <el-form :model="form" ref="form" :rules="rules" label-width="145px" :disabled="isFind">
        <el-form-item label="语言" prop="languageObj">
          <el-checkbox-group v-model="form.languageObj" @change="$forceUpdate()">
            <el-checkbox
                v-for="lang in languages"
                :label="lang.value"
                :key="lang.value"
            >{{lang.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- <el-form-item label="盲盒名称" prop="blindBoxName">
          <el-input v-model="form.blindBoxName"></el-input>
        </el-form-item>-->
        <el-form-item label="盲盒名称" prop="nameObj" style="margin-top: 20px">
          <span class="star">*</span>
          <div
              v-for="lang in form.languageObj"
              :key="lang"
              style="display: inline-block; margin-right: 10px;"
          >
            <el-input
                :value="nameObj[lang]"
                maxlength="50"
                :rules="[{ required: true, message: '名称不能为空'}]"
                :placeholder="languagesObj[lang]+'名称'"
                @change="nameObjChange(lang, $event)"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="盲盒等级" prop="blindBoxGrade">
          <el-select v-model="form.blindBoxGrade" placeholder="请选择盲盒等级">
            <el-option
                v-for="item in levelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付币种" prop="coin">
          <span class="star">*</span>
          <div v-for="(item, index) in coinForm" :key="index">
            <div class="flex-box">
              <el-autocomplete
                  class="input-number"
                  v-model="item.coinType"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入币种"
                  @select="handleSelect"
                  @keyup.native.enter="handleSearch"
              >
                <i
                    class="el-icon-close el-input__icon"
                    slot="suffix"
                    @click="cleanSearchCoin(coinForm, index, '')"
                    style="cursor: pointer"
                ></i>
              </el-autocomplete>
              <el-input class="input-number" maxlength="50" v-model="item.num" placeholder="请输入数量"></el-input>
              <i
                  class="el-icon-circle-plus-outline input-number"
                  type="danger"
                  v-if="index == 0"
                  @click="addItem"
              />
              <i
                  class="el-icon-remove-outline input-number"
                  type="danger"
                  v-if="index != 0"
                  @click="del(index)"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="免费开启邀请人数" prop="invitationNum">
          <el-input v-model.number="form.invitationNum" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="总盒子数" prop="blindBoxTotal">
          <el-input v-model.number="form.blindBoxTotal" :disabled="isEdit" maxlength="50"></el-input>
          <span style="padding-left: 30px;">白名单盒子数：</span>
          <el-input v-model.number="form.whiteBlindBoxTotal" :disabled="isEdit" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
              v-model="form.startTime"
              class="width300"
              type="datetime"
              value-format="timestamp"
              placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
              v-model="form.endTime"
              class="width300"
              type="datetime"
              value-format="timestamp"
              placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="填充奖品" prop="gift">
          <span class="star">*</span>
          <div v-for="(item, index) in gifList" :key="index">
            <div class="flex-box">
              <el-select class="input-number" v-model="item.type" placeholder="请选择" :disabled="isEdit">
                <el-option
                    v-for="item in giftType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
              <el-autocomplete
                  v-if="item.type === 1"
                  class="input-number"
                  v-model="item.goods"
                  :fetch-suggestions="querySearch"
                  :disabled="isEdit"
                  placeholder="请输入币种"
                  @select="handleSelect"
                  @keyup.native.enter="handleSearch"
              >
                <i
                    class="el-icon-close el-input__icon"
                    slot="suffix"
                    @click="cleanSearchCoinGift(gifList, index, '')"
                    style="cursor: pointer"
                ></i>
              </el-autocomplete>
              <el-select
                  v-else-if="item.type === 0 && !isEdit && !isFind"
                  class="input-number"
                  v-model="item.goods"
                  placeholder="请选择"
                  @change="selectChange"
                  :disabled="isEdit"
              >
                <el-option
                    v-for="(item, index) in nftGradeCount"
                    :key="index"
                    :label="`${item.grade}星 剩余${item.count}个`"
                    :value="item.grade"
                ></el-option>
              </el-select>
              <el-select
                  v-else-if="item.type === 0 && (isEdit || isFind)"
                  class="input-number"
                  v-model="item.goods"
                  placeholder="请选择"
                  @change="selectChange"
                  :disabled="isEdit"
              >
                <el-option
                    v-for="(item, index) in showNftCount"
                    :key="index"
                    :label="`${item}星`"
                    :value="item"
                ></el-option>
              </el-select>
              <div v-else-if="item.type === 2" class="gift-box">
                <div v-for="lang in form.languageObj" :key="lang">
                  <el-input
                      :value="item.showObj[lang]"
                      class="input-number"
                      maxlength="50"
                      :disabled="isEdit"
                      :placeholder="languagesObj[lang]+'实物奖品'"
                      @change="goodsChange(lang, $event, item)"
                  />
                </div>
              </div>
              <el-input class="input-number" v-model="item.num" placeholder="输入个数" :disabled="isEdit" @input="(val)=>{numInput(val, item.type)}"></el-input>
              <el-input
                  class="input-number"
                  v-model="item.probability"
                  :disabled="isEdit"
                  onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))"
              >
                <i slot="suffix">%</i>
              </el-input>
              <i
                  class="el-icon-circle-plus-outline input-number"
                  type="danger"
                  v-if="index == 0"
                  @click="addGifItem"
              />
              <i
                  class="el-icon-remove-outline input-number"
                  type="danger"
                  v-if="index != 0"
                  @click="delGif(index)"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="用户中奖数" prop="winningNum">
          <el-input v-model.number="form.winningNum" placeholder="输入抽中率" :disabled="isEdit" maxlength="50"></el-input>
        </el-form-item>
      </el-form>
      <div v-if="!isFind" slot="footer" class="dialog-footer">
        <el-button @click="closeBox">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import "./store";
import { mapState, mapActions } from "vuex";
import api from "./api";
import Pagination from "../../components/pagination";
import LANGUAGES from "../../common/languages_code";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      languagesObj: LANGUAGES,
      languages: Object.keys(LANGUAGES).map(lang => ({
        label: LANGUAGES[lang],
        value: lang
      })),
      status: "",
      statusList: [
        {
          label: "待上架",
          value: 0
        },
        {
          label: "已上架",
          value: 1
        },
        {
          label: "已下架",
          value: 2
        }
      ],
      levelList: [
        {
          label: "白银",
          value: 1
        },
        {
          label: "黄金",
          value: 2
        },
        {
          label: "铂金",
          value: 3
        },
        {
          label: "钻石",
          value: 4
        },
        {
          label: "超凡",
          value: 5
        }
      ],
      coinLevel: [
        {
          label: "一星",
          value: 1
        },
        {
          label: "二星",
          value: 2
        },
        {
          label: "三星",
          value: 3
        },
        {
          label: "四星",
          value: 4
        },
        {
          label: "五星",
          value: 5
        }
      ],
      giftType: [
        {
          label: "NFT",
          value: 0
        },
        {
          label: "代币",
          value: 1
        },
        {
          label: "实物",
          value: 2
        }
      ],
      nftNum: 0,
      title: "新增盲盒",
      boxShow: false,
      form: {
        name: "",
        level: "",
        languageObj: ["zh"]
      },
      nameObj: {},
      name: "",
      coinForm: [
        {
          coinType: "",
          num: ""
        }
      ],
      gifList: [
        {
          type: "",
          goods: "",
          num: "",
          probability: ""
        }
      ],
      goodsObj: {},
      goods: "",
      rules: {
        languageObj: [{ required: true, message: "请选择语言" }],
        blindBoxName: [
          { required: true, message: "请输入盲盒名称", trigger: "blur" }
        ],
        blindBoxGrade: [
          {
            required: true,
            message: "请选择盲盒等级",
            trigger: "change"
          }
        ],
        invitationNum: [
          { required: true, message: "请输入免费邀请人数", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 1000,
            message: "邀请人数在0-1000之间",
            trigger: "blur"
          }
        ],
        blindBoxTotal: [
          { required: true, message: "请输入总盒子数", trigger: "blur" },
          {
            type: "number",
            max: 1000000,
            message: "数量最多不能超过1000000",
            trigger: "blur"
          }
        ],
        startTime: [
          {
            type: "date",
            required: true,
            message: "请选择开始时间",
            trigger: "change"
          }
        ],
        endTime: [
          {
            type: "date",
            required: true,
            message: "请选择结束时间",
            trigger: "change"
          }
        ],
        winningNum: [
          { required: true, message: "请输入用户中奖次数", trigger: "blur" },
          {
            type: "number",
            message: "长度不能超过50个字符",
            trigger: "blur"
          }
        ]
      },
      isEdit: false,
      nftGradeCount: [],
      isFind: false,
      showNftCount: [], // 展示用
    };
  },
  computed: {
    ...mapState("newMagicBox", ["orderListData", "pagination", "total"])
  },
  filters: {
    langFormat(val) {
      if (val) {
        let langArr = JSON.parse(val);
        let newArr = [];
        let s = "";
        for (let i in langArr) {
          newArr.push({ [i]: langArr[i] });
        }
        // console.log(Object.keys(langArr)[0])
        for (let i = 0; i < newArr.length; i++) {
          console.log(Object.keys(langArr)[i]);
          if (i == 0) {
            s += LANGUAGES[Object.keys(langArr)[i]];
          } else {
            s += "," + LANGUAGES[Object.keys(langArr)[i]];
          }
        }
        return s;
      } else {
        return "";
      }
    }
  },
  methods: {
    ...mapActions("newMagicBox", ["getBoxListA"]),
    reset() {
      this.status = "";
    },
    getList(data = {}) {
      this.getBoxListA({
        state: this.status,
        ...this.pagination,
        ...data
      });
    },
    nameObjChange(lang, value) {
      this.nameObj[lang] = value;
      this.name = JSON.stringify(this.nameObj);
      //   this.$forceUpdate();
    },
    handlePageChanged(pageVal) {
      this.getList(pageVal);
    },
    getAllSupportCoin() {
      api.getAllSupportCoin().then(({ data }) => {
        this.coinTypes = data;
        this.$store.commit('newMagicBox/setAllCoins', data)
      });
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.coinTypes;
      results = queryString
          ? coinList.filter(this.createFilter(queryString))
          : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleSelect(val) {
      // console.log(val);
      // console.log(this.coinTypes.filter(item => item === val));
    },
    createFilter(queryString) {
      let tempData = this.coinTypes;
      return tempData => {
        return tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    cleanSearchCoin(list, index, data) {
      list[index].coinType = data;
    },
    cleanSearchCoinGift(list, index, data) {
      list[index].goods = data;
    },
    goodsChange(lang, value, item) {
      // this.goodsObj[lang] = value;
      // item.goods = JSON.stringify(this.goodsObj);
      this.$set(item.showObj, lang, value)
      item.goods = JSON.stringify(item.showObj);
      this.$forceUpdate();
    },
    addItem() {
      if (this.coinForm.length >= 10) {
        this.coinForm.splice(10, 1);
        return this.$message({
          message: "支付币种不能超过10个",
          type: "error"
        });
      }
      this.coinForm.push({
        coinType: "",
        num: ""
      });
    },
    del(index) {
      this.coinForm.splice(index, 1);
    },
    addGifItem() {
      if (this.isFind || this.isEdit) return
      this.gifList.push({
        type: "",
        goods: "",
        num: "",
        probability: "",
        showObj: {}
      });
    },
    delGif(index) {
      if (this.isFind || this.isEdit) return
      this.gifList.splice(index, 1);
    },
    closeBox() {
      this.boxShow = false;
      this.isFind = false;
      this.isEdit = false;
      // 清空表单数据
      this.$refs["form"].resetFields();
      this.form = {};
      this.nameObj = {};
      this.coinForm = [];
      this.gifList = [];
      this.form.languageObj = ["zh"];
    },
    updateStatus(row) {
      const data = {
        id: row.id,
        state: row.state != 1 ? 1 : 0
      };
      api.updateStatus(data).then(res => {
        if (row.state != 1) {
          this.$message({
            message: "发布成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "下架成功",
            type: "success"
          });
        }
        this.getList();
      });
    },
    // 新增
    add() {
      this.boxShow = true;
      this.title = "新增盲盒";
      this.isEdit = false;
      this.coinForm = [];
      this.gifList = [];
      this.addItem();
      this.addGifItem();
    },
    // 编辑
    editItem(row) {
      this.boxShow = true;
      this.title = "编辑盲盒";
      this.isEdit = true;
      this.showNftCount = [];
      api.getBoxInfo({ id: row.id }).then(res => {
        this.form = res.data;
        this.form.languageObj = JSON.parse(res.data.language);
        this.coinForm = JSON.parse(res.data.payInfo);
        this.nameObj = Object.assign(
            this.nameObj,
            JSON.parse(res.data.blindBoxName)
        );
        this.gifList = JSON.parse(res.data.rewardInfo);
        this.gifList.forEach((item, index) => {
          if (item.type === 0 && this.showNftCount.indexOf(item.goods) === -1) {
            this.showNftCount.push(item.goods)
          }
          if (item.type === 2) {
            this.$set(item, 'showObj', JSON.parse(item.goods))
            // this.goodsObj = JSON.parse(item.goods);
          }
        });
      });
    },
    // 查看
    infoItem(row) {
      this.boxShow = true;
      this.title = "查看盲盒";
      this.isFind = true;
      this.showNftCount = [];
      api.getBoxInfo({ id: row.id }).then(res => {
        this.form = res.data;
        this.form.languageObj = JSON.parse(res.data.language);
        this.coinForm = JSON.parse(res.data.payInfo);
        this.nameObj = Object.assign(
            this.nameObj,
            JSON.parse(res.data.blindBoxName)
        );
        this.gifList = JSON.parse(res.data.rewardInfo);
        this.gifList.forEach(item => {
          if (item.type === 0 && this.showNftCount.indexOf(item.goods) === -1) {
            this.showNftCount.push(item.goods)
          }
          if (item.type === 2) {
            this.$set(item, 'showObj', JSON.parse(item.goods))
            // this.goodsObj = JSON.parse(item.goods);
          }
        });
      });
    },
    // 删除
    delItem(row) {
      this.$confirm("删除后不可恢复，是否确认将此条数据删除？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      }).then(() => {
        api.deleteBox(row.id).then(res => {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getList();
        });
      });
    },
    submitForm(formName) {
      if (
          Object.keys(this.nameObj).length <
          Object.keys(this.form.languageObj).length ||
          !this.nameObj[this.form.languageObj[0]]
      ) {
        return this.$message({
          message: "请输入盲盒名称",
          type: "error"
        });
      }
      if (this.coinForm) {
        for (let item of this.coinForm) {
          if (!item.coinType || !item.num) {
            return this.$message({
              message: "请填写支付币种信息",
              type: "error"
            });
          }
        }
      }
      if (this.gifList) {
        for (let item of this.gifList) {
          if (item.type === "" || !item.goods || !item.num || !item.probability) {
            console.log(item.type !== "", !item.goods, !item.num, !item.probability)
            console.log(item, item.type, item.goods, item.num, item.probability)
            return this.$message({
              message: "请填写填充奖品信息",
              type: "error"
            });
          }
        }
      }
      if (this.form.whiteBlindBoxTotal && this.form.whiteBlindBoxTotal > this.form.blindBoxTotal) {
        return this.$message({ message: '白名单盒子数不能大于总盒子数', type: 'error' })
      }
      // 礼物总中奖率
      const gitfRate = this.gifList.map(item => {
        return item.probability !== "" ? Number(item.probability) : 0;
      });
      const totalGiftNum = gitfRate.reduce((p, n) => p + n);
      if (totalGiftNum !== 100) {
        return this.$message({
          message: "中奖率总和必须等于100",
          type: "error"
        });
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          const data = this.form;
          data.language = JSON.stringify(this.form.languageObj);
          data.blindBoxName = JSON.stringify(this.nameObj);
          data.payInfo = JSON.stringify(this.coinForm);
          data.rewardInfo = JSON.stringify(this.gifList);
          api.createOrUpdateBox(data).then(res => {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.boxShow = false;
            this.getList();
            this.$refs["form"].resetFields();
            this.form = {};
            this.nameObj = {};
            this.coinForm = [];
            this.gifList = [];
            this.form.languageObj = ["zh"];
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    nftLevelNum() {
      api.getNftLevelNum().then(res => {
        this.nftGradeCount = res.data;
      });
    },
    selectChange(val) {
      const onlyone = this.nftGradeCount.filter(res => res.grade === val);
      this.nftNum = onlyone[0].count;
    },
    numInput(val, item) {
      if (item === 0) { // 当为NFT时，判断数量
        if (Number(val) > this.nftNum) {
          return this.$message({
            message: "NFT数量大于剩余数量",
            type: "error"
          });
        }
      }
    },
    openWhiteList(row) {
      this.$store.commit('newMagicBox/setShowWhiteList', true)
      this.$store.commit('newMagicBox/setSelectData', row)
    },
  },
  created() {
    this.getAllSupportCoin();
    this.nftLevelNum();
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="less">
.magicBox {
  .page-actions {
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .list {
    .el-button + .el-button {
      margin-left: 10px;
    }
  }
  .el-input {
    width: 100px;
  }
  .page-actions {
    .el-input {
      width: 200px;
    }
    .el-input__inner {
      width: 200px;
    }
  }
  .el-input__inner {
    width: 100px;
  }
  .flex-box {
    display: flex;
    justify-content: start;
    margin-bottom: 10px;
    .input-number {
      margin-right: 10px;
    }
  }
  i.input-number {
    // font-size: 20px;
    line-height: 40px;
  }
  .gift-box {
    display: flex;
    flex-direction: column;
  }
  .el-input.width300 {
    width: 300px;
    .el-input__inner {
      width: 100%;
    }
  }
  .el-form-item__content {
    position: relative;
  }
  .star {
    position: absolute;
    left: -77px;
    color: #f56c6c;
  }
  .el-pagination__editor.el-input {
    width: 50px;
  }
  .el-pagination__jump .el-input__inner {
    width: auto;
  }
}
</style>
